"use client";
import { StaticImageData } from "next/image";
import ToolFeaturedArea, {
  THeroSectionInfoType,
} from "@/components/tools/ToolFeatured/ToolFeaturedArea";
import GrammarCheckerCoreSection from "@/components/tools/ToolFunctional/grammar-checker/GrammerCheckerCoreSection";
import { PageInfoProps } from "../summarizer/root";
import ConclusionSection, {
  ConclusionSectionFeatureProps,
} from "@/components/tools/ToolsCommon/ConclusionSection";
import TopInfoImageSection, {
  TopImageInfoType,
} from "@/components/tools/ToolsCommon/TopInfoImageSection";
import ToolTopArea from "@/components/tools/ToolTop/ToolTopArea";
import AiToolsFaq, {
  IFaqList,
} from "@/components/tools/ToolsCommon/AiToolsFaq";
import AdvTools from "@/components/tools/AdvTools/AdvTools";
import AdBanner from "@/components/Advertisement/AdBanner";

export type TAIPropTypes = {
  params: {
    pageInfo: PageInfoProps;
    heroSectionInfo: THeroSectionInfoType;
    stepsSectionFeatures: ConclusionSectionFeatureProps[];
    topInfoSectionFeature: TopImageInfoType;
    faqList: IFaqList[];
  };
};

export type TFeatureList = {
  title: string;
  subtitle: string;
  featuredImg: StaticImageData;
};

const GrammarCheckerPageRoot = ({ params }: TAIPropTypes) => {
  const {
    pageInfo,
    heroSectionInfo,
    faqList,
    stepsSectionFeatures,
    topInfoSectionFeature,
  } = params;

  return (
    <>
      <ToolTopArea pageInfo={pageInfo}>
        <div className="relative z-10 w-full overflow-hidden">
          <GrammarCheckerCoreSection />
        </div>
      </ToolTopArea>
      <AdvTools
        title={<>Get Kroolo, The best of {" "}
          <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
            AI Grammar Checker
          </span>
        </>
        }
        btnText="Try it free"
      />
      <TopInfoImageSection topInfoSection={topInfoSectionFeature} />
      <ToolFeaturedArea heroSectionInfo={heroSectionInfo} />
      <ConclusionSection
        title="Kroolo’s AI Grammar checker helps you write better faster and smarter "
        subtitle="Kroolo’s AI Paraphrasing Tool and AI Grammar Checker make writing effortless and error-free. With just a click, the paraphrasing tool rephrases your sentence, paragraph, report, or article to suit your preferences, while the grammar checker ensures polished and accurate content. Customize and refine your text easily, knowing Kroolo has your back-free and user-friendly!"
        featureArray={stepsSectionFeatures}
      />
      <AiToolsFaq faqTitle="AI Grammar Checker FAQs" faqList={faqList} />
      <AdBanner />
    </>
  );
};

export default GrammarCheckerPageRoot;
